import FirmApi from '../../services/FirmApi'

export const loader = {
    namespaced: true,
    state: {
        message: '',
        type: 'loader', // ['loader', 'success', 'info', 'error']
    },
    getters: {
        getMessage(state) {
            return state.message
        },
        getType(state) {
            return state.type
        },
    },
    mutations: {
        setMessage(state, message) {
            state.message = message
        },
        setType(state, type) {
            state.type = type
        },
    },
    actions: {
        /**
         * nastaví message a type
         * @param commit
         * @param loader
         */
        setLoader({ commit }, message) {
            commit('setMessage', message)
            commit('setType', 'loader')
        },
        setError({ commit }, message) {
            commit('setMessage', message)
            commit('setType', 'error')
            // throw new Error('loader::' + message)
            FirmApi.createLoggerMessage(message)
                .then(function(response) {
                    console.log(response)
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
    },
}
